<template>
    <div class="news-pane p-0" ref="newsPane">
        <div class="alert alert-danger" v-if="!hasSubdomain">
            サブドメイン未登録の場合、一言の投稿ができません。
        </div>
        <div class="mb-3" v-if="!$route.params.id && hasSubdomain">
            <nav class="tools d-flex justify-content-between">
                <ul>
                    <li class="nav-item">
                        <a class="nav-link" href="#" @click.prevent="ruby()">
                            <span class="d-none d-lg-block">
                                <ruby>ルビ<rt>ルビ</rt></ruby>
                                (ctrl+1)
                            </span>
                            <span class="d-md-block d-lg-none">
                                <ruby>亜<rt>あ</rt></ruby>
                            </span>
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="#" @click.prevent="emphasis()">
                            <span class="d-none d-lg-block">
                                <ruby>傍点<rt>丶丶</rt></ruby>
                                (ctrl+2)
                            </span>
                            <span class="d-md-block d-lg-none">
                                <ruby>点<rt>丶</rt></ruby>
                            </span>
                        </a>
                    </li>
                    <li class="nav-item dropdown">
                        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                            {{getRating(rating_id)}}
                        </a>
                        <div class="dropdown-menu">
                            <a href="#" class="dropdown-item" @click="setRating(null)">なし</a>
                            <a href="#" class="dropdown-item" @click="setRating(r.id)" v-for="r in ratings" :key="r.id">
                                {{r.rating_name}}
                            </a>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link pointer" href="#" @click="$refs.image.click()">
                            <i class="far fa-file-image"></i>
                            画像
                            <input type="file" ref="image" @change="imageSelected" accept="image/*" class="d-none" />
                        </a>
                    </li>
                </ul>
                <div class="news-length">
                    <circle-graph :value="newsLength"></circle-graph>
                </div>
            </nav>
            <div class="text-pane">
                <div class="text-pane-dummy">{{body + '\u200b'}}</div>
                <textarea class="text-pane-editor"
                    v-model="body"
                    id="news-edit"
                    maxlength="250"
                    @keydown.ctrl.1="ruby()"
                    @keydown.ctrl.2="emphasis()"
                    @keydown.ctrl.enter="save()"
                    @keydown.meta.enter="save()"
                    placeholder="近況報告や更新の通知、執筆状況など"></textarea>
            </div>
            <div class="row mb-3">
                <div class="col-lg small">
                    <span v-if="newsStatus">
                        {{$filters.numberFormat(news.total)}}
                        /
                        {{$filters.numberFormat($store.state.user.news_limit)}} 件
                    </span>
                </div>
                <div class="col-lg text-right">
                    <button type="button" class="btn btn-outline-primary" @click="save()" :disabled="disablePost">
                        一言投稿 (
                            <span v-if="isMac">⌘+Enter</span>
                            <span v-else>Ctrl+Enter</span>
                        )
                    </button>
                </div>
            </div>
            <div v-if="image.url" class="position-relative">
                <i class="far fa-times-circle remove-image" @click="removeImage()"></i>
                <div class="d-flex justify-content-center">
                    <img :src="image.url" class="img-thumbnail img-fluid" />
                </div>
            </div>
            <div v-else-if="hasUrl">
                <ogp-pane :url="lastUrl"></ogp-pane>
            </div>
        </div>

        <div class="sticky" v-if="!$route.params.id">
            <page :last_page="news.last_page" v-model="page" @goto="goto"></page>
        </div>

        <div class="mb-3" v-if="fixed_news && (!$route.params.id || fixed_news.id == $route.params.id)">
            <news-card
                :news="fixed_news"
                :fixed="true"
                :ratings="ratings"
                @opened="opened($event)"
                @closed="closed()"
                @load="load($event)">
                <div class="mb-3">
                    <i class="fas fa-thumbtack"></i> 固定
                </div>
            </news-card>
        </div>
        <div v-if="news.total">
            <news-card v-for="n in filteredNews"
                :key="n.id"
                :news="n"
                :ratings="ratings"
                @opened="opened($event)"
                @closed="closed()"
                @load="load($event)"></news-card>
        </div>
        <div v-else-if="!fixed_news && !isLoading" class="nothing">
            一言はありません。
        </div>
    </div>
</template>

<style scoped lang="scss">
.news-pane {
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}
.tools {
    height: 60px;
    ul {
        list-style: none;
        margin: 0px;
        padding: 0em;
        padding-left: 0em;
        vertical-align: middle;
        li {
            display: inline-block;
            margin-left: 0em;
            padding: 0;
            vertical-align: middle;
            .nav-link {
                padding: 1rem .7rem;
                margin: 0;
            }
        }
    }
    .news-length {
        padding: 15px 0;
        width: 30px;
    }
}
.remove-image {
    position: absolute;
    top: 1rem;
    right: 1rem;
    font-size: 2rem;
    cursor: pointer;
    &:hover {
        opacity: .8;
    }
}
.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 1px solid #bbb;
    border-radius: 0.4rem;
    font-size: 0.9rem;
    line-height: 1.8rem;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.9rem 1.25rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: 0.9rem 1.25rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>

<script>
import page from "components/Page";
import ogpPane from "components/Ogp";
import newsCard from "./newsCard";
import circleGraph from "components/circleGraph";
export default {
    components: {
        page,
        ogpPane,
        newsCard,
        circleGraph,
    },
    data() {
        return {
            body: "",
            rating_id: null,
            image: {},
            news: {},
            fixed_news: null,
            page: parseInt(this.$route.query.page || 1),
            MAXCHARS: 250,  // 最大文字数
            ratings: [],
            ogp: null,
            isLoading: false,
            retry: 0,
            opened_id: null,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            this.$router.push({query: {page: p}});
            setTimeout(() => {this.load();});
            const offsetTop = this.$refs.newsPane.getBoundingClientRect().top + window.scrollY - 50;
            $("html,body").animate({scrollTop: offsetTop}, 300);
        },
        load(scrollTop = null) {
            if (this.opened_id) return;
            if (scrollTop !== null) {
                $("html,body").animate({scrollTop: scrollTop}, 0);
            }
            this.isLoading = true;
            axios.get("/mypage/news/get", {params: {
                page: this.page,
                id: this.$route.params.id || null
            }}).then(res => {
                this.news = res.data.news;
                this.fixed_news = res.data.fixed_news;
                this.isLoading = false;
                setTimeout(() => {
                    this.connectChannel();
                });
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        },
        save() {
            if (this.disablePost) return;
            if (this.isLoading) return;
            if (this.image.url) {
                this.imageUpload();
                return;
            }
            this.isLoading = true;
            axios.post("/mypage/news/save", {
                body: this.body,
                rating_id: this.rating_id,
            }).then(res => {
                this.isLoading = false;
                this.body = "";
                alert.msg(res.data);
                this.load();
            }).catch(err => {
                this.isLoading = false;
                alert.err(err.response);
            });
        },
        ruby() {
            const range = {
                start: $("#news-edit").get(0).selectionStart,
                end: $("#news-edit").get(0).selectionEnd,
            };
            let word = "";
            if (range.start < range.end) {
                word = this.body.slice(range.start, range.end)
            }
            const ruby = "｜" + word + "《ルビを入力…》";
            const before = this.body.slice(0, range.start);
            const after = this.body.slice(range.end);
            const carret = {
                start: range.start + ruby.length - 7,
                end: range.start + ruby.length - 1
            };
            this.body = before + ruby + after;
            setTimeout(() => {
                document.getElementById("news-edit").setSelectionRange(carret.start, carret.end);
                document.getElementById("news-edit").focus();
            });
        },
        emphasis() {
            const range = {
                start: $("#news-edit").get(0).selectionStart,
                end: $("#news-edit").get(0).selectionEnd,
            };
            let word = "";
            if (range.start < range.end) {
                word = this.body.slice(range.start, range.end)
            }
            const ruby = "《《"+word+"》》";
            const before = this.body.slice(0, range.start);
            const after = this.body.slice(range.end);
            const carret = range.start + ruby.length - (word ? 0 : 2);
            this.body = before + ruby + after;
            setTimeout(() => {
                document.getElementById("news-edit").setSelectionRange(carret, carret);
                document.getElementById("news-edit").focus();
            });
        },
        removeImage() {
            this.image.info = null
            this.image.url = "";
        },
        imageSelected() {
            if (this.$refs.image.files[0].size > 1024 * 1024 * 5) {
                alert.err("ファイルサイズが大きすぎます: " + this.$filters.getByte(this.$refs.image.files[0].size));
                return;
            }
            this.image.info = this.$refs.image.files[0];
            this.image.url = URL.createObjectURL(this.image.info);
        },
        imageUpload() {
            this.isLoading = true;
            const fd = new FormData();
            fd.append('image', this.image.info);
            fd.append('image_url', this.image.url);
            fd.append('body', this.body);
            if (this.rating_id) {
                fd.append('rating_id', this.rating_id);
            }
            axios.post("/mypage/news/upload", fd).then(res => {
                this.body = "";
                this.image = {};
                // this.load(true);
            }).catch(err => {
                alert.err(err.response);
                this.isLoading = false;
            }).finally(() => {
                this.isLoading = false;
            });
        },
        setRating(rating_id) {
            this.rating_id = rating_id;
        },
        getRating(rating_id) {
            const rate = _.find(this.ratings, {id: rating_id});
            if (rate) {
                return rate.rating_name;
            }
            return "なし";
        },
        connectChannel() {
            if (!this.$store.state?.user?.subdomain) {
                if (this.retry++ > 30) return;
                setTimeout(() => {this.connectChannel()}, 500);
                return;
            }
            if (!Echo.connector?.channels["news." + this.$store.state.user.subdomain]) {
                Echo.channel("news." + this.$store.state.user.subdomain).listen("News\\NewsUpdate", (e) => {
                    this.load();
                });
            }
        },
        leaveChannel() {
            Echo.leaveChannel("news." + this.$store.state.user.subdomain);
        },
        opened(id) {
            this.opened_id = id;
        },
        closed() {
            this.opened_id = null;
        },
    },
    computed: {
        filteredNews() {
            if (this.$route?.params?.id && this.news?.data) {
                const res = _.find(this.news.data, {id: parseInt(this.$route.params.id)});
                if (!res) return [];
                return [res];
            }
            return this.news.data;
        },
        disablePost() {
            if (this.body.length > this.MAXCHARS || this.body.length === 0) {
                return true;
            }
            return false;
        },
        newsStatus() {
            if (!this.$store.state?.user?.news_limit || !this.news?.total) {
                return false;
            }
            return true;
        },
        hasSubdomain() {
            return this.$store.state?.user?.subdomain;
        },
        hasUrl() {
            return this.body.match(/(https?:\/\/[\w!?\/+\-_~;.,*&@#$%()'[\]]+)/g);
        },
        lastUrl() {
            const matches = this.hasUrl;
            if (matches) {
                return matches.pop();
            }
            return null;
        },
        isMac() {
            return navigator.userAgent.match(/Macintosh/i);
        },
        newsLength() {
            return this.body.length / 250 * 100;
        },
    },
    mounted() {
        axios.get("/master/ratings").then(res => {
            this.ratings = res.data;
        }).catch(err => { alert.err(err.response) });
        this.load();
    },
    unmounted() {
        this.leaveChannel();
    }
}
</script>